import axiosHttp from "../../config/axios.interceptor";
import { chatReducerConstant } from "../reducerConstant";

export const getActiveChatNotificationCount = () => async (dispatch) => {
  try {
    const notificationData = await axiosHttp.get(`unread-chat-queries-count`);
    let data = notificationData?.data?.data?.UnreadChatQueryCount;

    dispatch({
      type: chatReducerConstant.GET_ACTIVE_CHAT_COUNT,
      payload: data || 0,
    });
  } catch (error) {}
};
